import { useQuery } from '@tanstack/react-query';

import { TEAMS_OPTIONS_QUERY_KEY } from '@/hooks/constants';
import { getTeamsOptions } from '@/infrastructure/network/data/team-league/teams-options';
import { useOrganizationStore } from '@/store/organization-store';

interface UseTeamsOptionsQueryParams {
	seasonUuid?: string;
	playerUuid?: string;
	isEnabled?: boolean;
}

export const useTeamsOptionsQuery = ({ seasonUuid, playerUuid, isEnabled = true }: UseTeamsOptionsQueryParams = {}) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: [TEAMS_OPTIONS_QUERY_KEY, store.organizationUuid, store.teamLeagueUuid, seasonUuid, playerUuid],
		queryFn: () =>
			getTeamsOptions({
				organizationUuid: store.organizationUuid,
				teamLeagueUuid: store.teamLeagueUuid,
				seasonUuid,
				playerUuid
			}),
		enabled: isEnabled && !!store.organizationUuid && !!store.teamLeagueUuid
	});
};
